<template>
  <div class="jps-curation-text is-size-6-desktop is-size-7-touch">
    <BaseSectionContainer
      tag="div"
      size="middle"
    >
      <DeltaRenderer :delta="ld(def)" class="jps-curation-text-body" />
    </BaseSectionContainer>
  </div>
</template>

<script lang="ts" setup>
const { ld } = useI18n()

interface Props {
  def: PartText
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
.jps-curation-text {
  .delta-renderer.content p:first-child {
    font-weight: 400;
  }
}
.jps-curation-text-body {
  // REVIEW これが原因でliが右にずれる
  //text-indent: 0;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
</style>
